export default __webpack_public_path__ + "static/4-414e1b8e3c4a973d0198cc61591ac18a.png";